/**
 * Creates a cache key for a visualization group based on its associated slot selections.
 * @param {string} groupId - The visualization group ID (or 'legacy' for legacy mode)
 * @param {Array<{id: string, selected: any}>} groupSlots - The slots associated with this group
 * @param {string} productVariantId - The selected product variant ID
 * @returns {string} A cache key string
 */
export const createGroupCacheKey = (groupId, groupSlots, productVariantId) => {
  // Create a stable key based on slot IDs and their selected values
  // For File objects, we use a combination of name, size, and lastModified
  const slotKey = groupSlots
    .map((slot) => {
      const selected = slot.selected;
      if (selected instanceof File) {
        // For files, use metadata that identifies the file uniquely
        return `${slot.id}:file:${selected.name}:${selected.size}:${selected.lastModified}`;
      } else if (selected && typeof selected === 'object') {
        // For objects (like text selections), stringify them
        return `${slot.id}:${JSON.stringify(selected)}`;
      } else {
        // For primitives, use the value directly
        return `${slot.id}:${selected}`;
      }
    })
    .sort()
    .join('|');

  return `${groupId}:${productVariantId}:${slotKey}`;
};
